@if (!!text) {
<div class="tooltip-container" [ngClass]="{'disabled': disabled}">
  @if (link !== 'icon') {
    <span [ngClass]="linkCss" class="tooltip-link" (click)="toggleTooltip()">{{ link }}</span>
  }
  @if (link === 'icon' || useBothTogglers) {
    <span class="icon-info" (click)="toggleTooltip()"></span>
  }
  <div class="tooltip-wrapper" [ngClass]="{'active': active}">
    <div class="tooltip-text">{{ text }}</div>
    <span class="icon-close" (click)="toggleTooltip()"></span>
  </div>
</div>
}
